import React from 'react';
import { FaExclamationTriangle, FaCheckCircle, FaFireAlt, FaTimesCircle } from 'react-icons/fa';
import { WARNING_STATES } from '../../context/enums';
import './WarningBanner.css';

/**
 * WarningBanner component - Displays system status messages and warnings
 * @param {Object} props - Component properties
 * @param {string} props.message - The message to display in the banner
 * @param {string} [props.status='normal'] - The status type ('normal', 'active', 'presoaking', or 'error')
 * @returns {JSX.Element} The rendered warning banner with appropriate styling
 */
const WarningBanner = ({ message, status = WARNING_STATES.NORMAL }) => {
  // Get the appropriate icon based on status
  const getIcon = () => {
    switch (status) {
      case WARNING_STATES.ACTIVE.status:
        return <FaFireAlt className="active-icon" />;
      case WARNING_STATES.PRESOAKING.status:
        return <FaFireAlt className="presoaking-icon" />;
      case WARNING_STATES.COLLABORATIVE.status:
        return <FaFireAlt className="collaborative-icon" />;
      case WARNING_STATES.ERROR.status:
        return <FaTimesCircle className="error-icon" />;
      case WARNING_STATES.NORMAL.status:
      default:
        return <FaCheckCircle className="normal-icon" />;
    }
  };
  
  // Get default message based on status
  const getDefaultMessage = () => {
    switch (status) {
      case WARNING_STATES.ACTIVE.status:
        return WARNING_STATES.ACTIVE.message;
      case WARNING_STATES.PRESOAKING.status:
        return WARNING_STATES.PRESOAKING.message;
      case WARNING_STATES.ERROR.status:
        return WARNING_STATES.ERROR.message;
      case WARNING_STATES.NORMAL.status:
      default:
        return WARNING_STATES.NORMAL.message;
    }
  };
  
  return (
    <div className={`warning-banner ${status}`}>
      {getIcon()}
      <span>{message || getDefaultMessage()}</span>
    </div>
  );
};

export default WarningBanner;